import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActionType } from '../../../actions/model';
import { ClientAccountsReportViewModel } from '../../../../common/model/client/clientAccountsReport';

export interface AdminClientsReportsState {
    list: ClientAccountsReportViewModel[] | null;
    isLoading: boolean;
    isLoaded: boolean;
    isLoadingExcel: boolean;
}

const initialState: AdminClientsReportsState = {
    list: null,
    isLoading: false,
    isLoaded: false,
    isLoadingExcel: false,
};

export const adminClientsReportsSlice = createSlice({
    name: '@@vp/clients/reports/list',
    initialState,
    reducers: {
        setClientsReportsList(state, action: PayloadAction<ClientAccountsReportViewModel[]>): void {
            state.list = action.payload;
            state.isLoaded = true;
        },
        setLoadingClientsReports(state, action: PayloadAction<AdminClientsReportsState['isLoading']>): void {
            state.isLoading = action.payload;
        },
        setLoadingClientsReportsLogsExcel(state, action: PayloadAction<AdminClientsReportsState['isLoadingExcel']>): void {
            state.isLoadingExcel = action.payload;
        },
        clearClientsReports(state): void {
            state.list = null;
            state.isLoading = false;
            state.isLoaded = false;
        },
    },
    extraReducers: {
        [ActionType.LOGOUT]: (): AdminClientsReportsState => initialState,
    }
});

export const {
    setClientsReportsList,
    setLoadingClientsReports,
    clearClientsReports,
    setLoadingClientsReportsLogsExcel
} = adminClientsReportsSlice.actions;
